export interface PaymentMethod {
  code: string;
  name: string;
  description: string;
}

export interface PaymentDeadlineOption {
  days: number;
  name: string;
  description: string;
}

export interface Currency {
  code: string;
  name: string;
  symbol: string;
}

export interface Language {
  code: string;
  name: string;
}

export interface PaymentSettings {
  maxPaymentDeadlineDays: number;
  minPaymentDeadlineDays: number;
  defaultPaymentMethod: string;
  defaultCurrency: string;
  defaultLanguage: string;
  defaultPaymentDeadline: number;
}

export interface PaymentOptions {
  paymentMethods: PaymentMethod[];
  paymentDeadlineOptions: PaymentDeadlineOption[];
  currencies: Currency[];
  languages: Language[];
  settings: PaymentSettings;
}

export const paymentOptions: PaymentOptions = {
  paymentMethods: [
    { code: 'CASH', name: 'Készpénz', description: 'Készpénzes fizetés' },
    { code: 'CARD', name: 'Bankkártya', description: 'Bankkártyás fizetés' },
    { code: 'TRANSFER', name: 'Átutalás', description: 'Banki átutalás' },
    { code: 'COD', name: 'Utánvét', description: 'Utánvétes fizetés' },
    { code: 'ONLINE', name: 'Online fizetés', description: 'Online banki fizetés' },
    { code: 'CHEQUE', name: 'Csekk', description: 'Csekkes fizetés' },
    { code: 'INSTALLMENT', name: 'Részletfizetés', description: 'Részletekben történő fizetés' },
    { code: 'COMPENSATION', name: 'Beszámítás', description: 'Követelés beszámítása' },
    { code: 'VOUCHER', name: 'Utalvány', description: 'Utalvánnyal történő fizetés' },
    { code: 'BARTER', name: 'Barter', description: 'Barter ügylet' },
    { code: 'CREDIT', name: 'Hitel', description: 'Hitelező fizetés' },
    { code: 'CLEARING', name: 'Klíring', description: 'Klíring rendszeren keresztül' },
    { code: 'FACTORING', name: 'Faktoring', description: 'Faktoring szolgáltatás' }
  ],
  paymentDeadlineOptions: [
    { days: 0, name: 'Azonnali', description: 'Azonnali fizetés' },
    { days: 3, name: '3 nap', description: '3 napos fizetési határidő' },
    { days: 8, name: '8 nap', description: '8 napos fizetési határidő (alapértelmezett)' },
    { days: 15, name: '15 nap', description: '15 napos fizetési határidő' },
    { days: 30, name: '30 nap', description: '30 napos fizetési határidő' },
    { days: 60, name: '60 nap', description: '60 napos fizetési határidő' },
    { days: 90, name: '90 nap', description: '90 napos fizetési határidő' }
  ],
  currencies: [
    { code: 'HUF', name: 'Magyar forint', symbol: 'Ft' },
    { code: 'EUR', name: 'Euro', symbol: '€' },
    { code: 'USD', name: 'US dollár', symbol: '$' },
    { code: 'GBP', name: 'Brit font', symbol: '£' },
    { code: 'CHF', name: 'Svájci frank', symbol: 'CHF' }
  ],
  languages: [
    { code: 'hu', name: 'Magyar' },
    { code: 'en', name: 'English' },
    { code: 'de', name: 'Deutsch' },
    { code: 'fr', name: 'Français' },
    { code: 'it', name: 'Italiano' },
    { code: 'ro', name: 'Română' },
    { code: 'sk', name: 'Slovenčina' },
    { code: 'hr', name: 'Hrvatski' }
  ],
  settings: {
    maxPaymentDeadlineDays: 365,
    minPaymentDeadlineDays: 0,
    defaultPaymentMethod: 'TRANSFER',
    defaultCurrency: 'HUF',
    defaultLanguage: 'hu',
    defaultPaymentDeadline: 8
  }
}; 